import { pipe } from 'ramda';

import { buildCmsUrl, CMSApiBase, getResponseCMS } from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';

export enum Medal {
  Gold = 'gold',
  Silver = 'silver',
  Bronze = 'bronze',
}

export type PrimeWinnerType = {
  name: string;
  medal: Medal;
  prize: string;
  id?: number;
};

export interface StarWinnersApi extends CMSApiBase {
  primeWinners: PrimeWinnerType[];
}

export const starWinnersCMSV3 = (lang: string) =>
  request<StarWinnersApi>({
    url: buildCmsUrl({ path: 'star-winners-block', lang }),
  });

export const starWinnersCMSV4 = (lang: string) =>
  request<StarWinnersApi>({
    url: buildCmsUrl({
      path: 'star-winners-block',
      lang,
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<StarWinnersApi>
    ),
  });

export const starWinnersCMS = isCMSV3 ? starWinnersCMSV3 : starWinnersCMSV4;
